import { render, staticRenderFns } from "./cb.vue?vue&type=template&id=61d4a5f0&scoped=true&"
import script from "./cb.vue?vue&type=script&lang=js&"
export * from "./cb.vue?vue&type=script&lang=js&"
import style0 from "./cb.vue?vue&type=style&index=0&id=61d4a5f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d4a5f0",
  null
  
)

export default component.exports